import { CSSProperties, FC, memo, useContext, useEffect, useState } from 'react';
import { useMethods } from '@lhb/hook';
import IconFont from '@/common/components/IconFont';
import styles from './index.module.less';
import cs from 'classnames';
import MapHelpfulContext from '../MapHelpfulContext';
import { useBigdataFn } from '@/common/utils/bigdata';
// 卫星图插件
// 组件如果直接使用在Amap组件下会自动注入_mapIns
// 插入TileLayer不必引入插件，AMap.MapType切换卫星图需要引入插件
const Satellite: FC<{
  _mapIns?: any;
  style?: CSSProperties;
  className?: string;
  URLParamsRef?:any;
  setSelected?:Function;
  satelliteEventId?:string;
  setTargetOperation?:Function;
}> = ({
  _mapIns,
  style,
  className,
  URLParamsRef,
  setSelected,
  satelliteEventId,
  setTargetOperation
}) => {
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [show, setShow] = useState<boolean>(false);
  const helpfulContext: any = useContext(MapHelpfulContext);

  useEffect(() => {
    const { stateEvent } = helpfulContext;
    if (!stateEvent) return;
    stateEvent((state) => ({
      ...state,
      toolBox: {
        ...state.toolBox,
        satellite: {
          value: show
        }, // 卫星
      },
    }));
  }, [show, helpfulContext?.stateEvent]);

  useEffect(() => {
    if (!_mapIns) return;
    _mapIns.addLayer(new window.AMap.TileLayer.Satellite({ visible: false }));
  }, [_mapIns]);
  const {
    onChangeShow
  } = useMethods({
    onChangeShow: () => {
      if (URLParamsRef) {
        URLParamsRef.current.satellite = !show;
      }
      const type = !show;
      setShow(!show);
      setSelected && setSelected((state) => !show ? state + 1 : state - 1);
      const layers = _mapIns.getLayers();
      layers.forEach(layer => layer.CLASS_NAME === 'AMap.TileLayer.Satellite' && (type ? layer.show() : layer.hide()));
      satelliteEventId && bigdataFn(satelliteEventId, '工具箱-卫星', '点击了工具箱卫星', { op_block: '工具箱', op_event: ``, });
    }
  });
  useEffect(() => {
    show ? setTargetOperation?.('satellite') : setTargetOperation?.('');
  }, [show]);
  return <div
    className={
      cs(styles.satellite,
        className,
        'bg-fff pointer selectNone',
        show && styles.satelliteSelected)
    }
    onClick={onChangeShow}
    style={style} >
    <div className={
      cs(show && styles.satelliteConSelected)
    }>
      <IconFont
        iconHref='iconic_weixing'
        style={{ width: '18px', height: '18px' }} />
      <span className='inline-block ml-5 c-222'>卫星</span>
    </div>

  </div>;
};

export default memo(Satellite);
